// Dependencies
import React, { Component } from 'react';
import RegistrationFormStepTitleComponent from '../form-step-title/form-step-title';

// Primereact imports
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';

// Multi lang
import { getLanguage, withTranslation } from 'react-multi-lang';

// Styling
import './step-5.scss';

// Redux
import { connect } from 'react-redux';
import { updateFormStep, updateStep5State } from '../../../redux/actions/form';

// Utils
import { getFormValue } from '../../../common/utils/form-utils';
import { FORM_FIELD_HAS_PHYSIO_POST_GRAD, FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_DATE, FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_SCHOOL, FORM_FIELD_PHYSIO_POST_GRAD_DEGREE_LEVEL, FORM_FIELD_PHYSIO_POST_GRAD_END_DATE, FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_COUNTRY, FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_SCHOOL, FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_TITLE, FORM_STEP_5_STATE, REGISTRATION_STATE_REVISION, STEP_STATE_SUBMITTED, STEP_STATE_VALIDATION_ERROR } from '../../../common/constants';
import { formatYesNoDropdownLists, getYesNoDropdownList } from '../../../common/utils/form-data-utils';
import { getPhysioPostGradList } from '../../../common/lists/qualification';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { WORLD_LIST } from '../../../common/lists/countries';
import { isMobileOnly } from 'react-device-detect';

class RegistrationFormStep5Component extends Component {

    constructor(props) {
        super(props);
        this.state = {
            addTrainingMode: false,
            hasPhysioPostGrads: false,
            physioPostGrads: [],
            // Cursor variables
            cursorDegree: null,
            cursorTrainingTitle: "",
            cursorEndDate: null,
            cursorTrainingSchool: "",
            cursorTrainingCountry: null,
            cursorAcceptanceSchool: "",
            cursorAcceptanceDate: null,
            // Mandatory fields validation
            validDegree: true,
            validTrainingTitle: true,
            validEndDate: true,
            validSchoolCountry: true,
            validTrainingSchool: true,
            // Physio Post Grads validation 
            validPhysioPostGradDegree: [true, true, true, true, true, true, true, true, true, true],
            validPhysioPostGradTrainingTitle: [true, true, true, true, true, true, true, true, true, true],
            validPhysioPostGradEndDate: [true, true, true, true, true, true, true, true, true, true],
            validPhysioPostGradSchoolCountry: [true, true, true, true, true, true, true, true, true, true],
            validPhysioPostGradTrainingSchool: [true, true, true, true, true, true, true, true, true, true]
        }
    }

    setTrainingMode() {
        this.setState({
            addTrainingMode: true
        });
    }

    componentDidMount() {
        this.setState({
            hasPhysioPostGrads: formatYesNoDropdownLists(getFormValue(FORM_FIELD_HAS_PHYSIO_POST_GRAD, this.props.formFields), this.props.language)
        });

        let physioPostGrads = [];

        for (let i = 1; i < 11; i++) {
            if(getFormValue((FORM_FIELD_PHYSIO_POST_GRAD_DEGREE_LEVEL + i.toString()), this.props.formFields) !== null) {
                physioPostGrads.push({
                    order: i,
                    degreeLevel: getFormValue((FORM_FIELD_PHYSIO_POST_GRAD_DEGREE_LEVEL + i.toString()), this.props.formFields),
                    trainingTitle: getFormValue((FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_TITLE + i.toString()), this.props.formFields),
                    endDate: getFormValue((FORM_FIELD_PHYSIO_POST_GRAD_END_DATE + i.toString()), this.props.formFields),
                    trainingSchool: getFormValue((FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_SCHOOL + i.toString()), this.props.formFields),
                    trainingCountry: getFormValue((FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_COUNTRY + i.toString()), this.props.formFields),
                    acceptanceSchool: getFormValue((FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_SCHOOL + i.toString()), this.props.formFields),
                    acceptanceDate: getFormValue((FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_DATE + i.toString()), this.props.formFields)
                });
            }
        }

        this.setState({
            physioPostGrads: physioPostGrads
        });
    }

    validateForm() {
        let validationResult = true;

        let validPhysioPostGradDegree = [true, true, true, true, true, true, true, true, true, true];
        let validPhysioPostGradTrainingTitle = [true, true, true, true, true, true, true, true, true, true];
        let validPhysioPostGradEndDate = [true, true, true, true, true, true, true, true, true, true];
        let validPhysioPostGradSchoolCountry = [true, true, true, true, true, true, true, true, true, true];
        let validPhysioPostGradTrainingSchool = [true, true, true, true, true, true, true, true, true, true];

        for (let i = 0; i < validPhysioPostGradDegree.length; i++) {
            if(i+1 > this.state.physioPostGrads.length) {
                validPhysioPostGradDegree[i] = true;
                validPhysioPostGradTrainingTitle[i] = true;
                validPhysioPostGradEndDate[i] = true;
                validPhysioPostGradSchoolCountry[i] = true;
                validPhysioPostGradTrainingSchool[i] = true;
            }
            else {
                validPhysioPostGradDegree[i] = (this.state.physioPostGrads[i].degreeLevel !== null);
                validPhysioPostGradTrainingTitle[i] = (this.state.physioPostGrads[i].trainingTitle !== "");
                validPhysioPostGradEndDate[i] = (this.state.physioPostGrads[i].endDate !== null);
                validPhysioPostGradSchoolCountry[i] = (this.state.physioPostGrads[i].trainingCountry !== null);
                validPhysioPostGradTrainingSchool[i] = (this.state.physioPostGrads[i].trainingSchool !== "");
            }
        }

        this.setState({
            validPhysioPostGradDegree: validPhysioPostGradDegree,
            validPhysioPostGradTrainingTitle: validPhysioPostGradTrainingTitle,
            validPhysioPostGradEndDate: validPhysioPostGradEndDate,
            validPhysioPostGradSchoolCountry: validPhysioPostGradSchoolCountry,
            validPhysioPostGradTrainingSchool: validPhysioPostGradTrainingSchool,
            validDegree: (this.state.addTrainingMode === false || this.state.cursorDegree !== null),
            validTrainingTitle: (this.state.addTrainingMode === false || this.state.cursorTrainingTitle !== ""),
            validEndDate: (this.state.addTrainingMode === false || this.state.cursorEndDate !== null),
            validSchoolCountry: (this.state.addTrainingMode === false || this.state.cursorTrainingCountry !== null),
            validTrainingSchool: (this.state.addTrainingMode === false || this.state.cursorTrainingSchool !== "")
        });

        validationResult = (
            (this.state.addTrainingMode === false || this.state.cursorDegree !== null) &&
            (this.state.addTrainingMode === false || this.state.cursorTrainingTitle !== "") &&
            (this.state.addTrainingMode === false || this.state.cursorEndDate !== null) &&
            (this.state.addTrainingMode === false || this.state.cursorTrainingCountry !== null) &&
            (this.state.addTrainingMode === false || this.state.cursorTrainingSchool !== "") &&
            this.ruleCollectionIsValid(validPhysioPostGradDegree) &&
            this.ruleCollectionIsValid(validPhysioPostGradTrainingTitle) &&
            this.ruleCollectionIsValid(validPhysioPostGradEndDate) &&
            this.ruleCollectionIsValid(validPhysioPostGradSchoolCountry) &&
            this.ruleCollectionIsValid(validPhysioPostGradTrainingSchool));

        return validationResult;
    }

    ruleCollectionIsValid(collection) {
        for (let i = 0; i < collection.length; i++) {
            if(collection[i] === false) return false;
        }

        return true;
    }

    submitStep() {
        if(this.validateForm()) {
            this.props.updateStep5State(STEP_STATE_SUBMITTED);

            let formValues = [
                { key: FORM_STEP_5_STATE, value: STEP_STATE_SUBMITTED },
                { key: FORM_FIELD_HAS_PHYSIO_POST_GRAD, value: this.state.hasPhysioPostGrads }
            ]

            for (let i = 0; i < this.state.physioPostGrads.length; i++) {
                formValues.push({ key: (FORM_FIELD_PHYSIO_POST_GRAD_DEGREE_LEVEL + i.toString()), value: this.state.physioPostGrads[i].degreeLevel });
                formValues.push({ key: (FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_TITLE + i.toString()), value: this.state.physioPostGrads[i].trainingTitle });
                formValues.push({ key: (FORM_FIELD_PHYSIO_POST_GRAD_END_DATE + i.toString()), value: this.state.physioPostGrads[i].endDate });
                formValues.push({ key: (FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_SCHOOL + i.toString()), value: this.state.physioPostGrads[i].trainingSchool });
                formValues.push({ key: (FORM_FIELD_PHYSIO_POST_GRAD_TRAINING_COUNTRY + i.toString()), value: this.state.physioPostGrads[i].trainingCountry });
                formValues.push({ key: (FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_SCHOOL + i.toString()), value: this.state.physioPostGrads[i].acceptanceSchool });
                formValues.push({ key: (FORM_FIELD_PHYSIO_POST_GRAD_ACCEPTANCE_DATE + i.toString()), value: this.state.physioPostGrads[i].acceptanceDate });
            }

            this.props.updateFormStep(1, formValues, () => this.props.onNext());
        }
        else {
            this.props.updateStep5State(STEP_STATE_VALIDATION_ERROR);

            this.props.updateFormStep(1, 
                [
                    { key: FORM_STEP_5_STATE, value: STEP_STATE_VALIDATION_ERROR }
                ],
                () => {});
        }
    }

    savePostGradData() {
        if(this.validateForm()) {
            let physioPostGrads = this.state.physioPostGrads;

            physioPostGrads.push({
                order: physioPostGrads.length + 1,
                degreeLevel: this.state.cursorDegree,
                trainingTitle: this.state.cursorTrainingTitle,
                endDate: this.state.cursorEndDate,
                trainingSchool: this.state.cursorTrainingSchool,
                trainingCountry: this.state.cursorTrainingCountry,
                acceptanceSchool: this.state.cursorAcceptanceSchool,
                acceptanceDate: this.state.cursorAcceptanceDate,
                addTrainingMode: false
            });
    
            this.setState({
                physioPostGrads: physioPostGrads
            });
        }
    }

    cancelAddPostGradData() {
        this.setState({
            addTrainingMode: false,
            cursorDegree: null,
            cursorTrainingTitle: "",
            cursorEndDate: null,
            cursorTrainingSchool: "",
            cursorTrainingCountry: null,
            cursorAcceptanceSchool: "",
            cursorAcceptanceDate: null,
            validDegree: true,
            validTrainingTitle: true,
            validEndDate: true,
            validSchoolCountry: true,
            validTrainingSchool: true
        });
    }

    updatePostGradData(order, field, value) {
        let physioPostGrads = this.state.physioPostGrads;

        for (let i = 0; i < this.state.physioPostGrads.length; i++) {
            if(this.state.physioPostGrads[i].order === order) {
                physioPostGrads[i][field] = value;
            }
        }

        this.setState({
            physioPostGrads: physioPostGrads
        });
    }

    deletePostGradData(order) {
        let physioPostGrads = [];

        for (let i = 0; i < this.state.physioPostGrads.length; i++) {
            if(this.state.physioPostGrads[i].order !== order) {
                let postGrad = this.state.physioPostGrads[i];
                postGrad.order = (physioPostGrads.length + 1);
                physioPostGrads.push(postGrad);
            }
        }

        this.setState({
            physioPostGrads: physioPostGrads
        });
    }

    render() {
        return (
                <>
                    <div id="data-container" className="card p-fluid mgt-20">
                        <div className="grid">
                            <div className="col-12">
                                <div className="grid mgt-10">
                                    <RegistrationFormStepTitleComponent title={this.props.t("registration-form.step-5.title")}
                                                                        subtitles={[ this.props.t("registration-form.step-5.subtitle-1") ]} />
                                    <div className='col-12 t-align-left'>
                                        <label htmlFor="hasTraining">{this.props.t("profile.areas.qualification.areas.physio-post-grad.has-training")} <span className="invalid-message">*</span></label>
                                        <Dropdown id="hasTraining" disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} value={this.state.hasPhysioPostGrads} options={getYesNoDropdownList(getLanguage())} optionLabel="name" onChange={(evt) => this.setState({ hasPhysioPostGrads: evt.value })}></Dropdown>
                                    </div>
                                    {
                                        this.state.physioPostGrads.map((grad) => {
                                            return <div key={grad.order} className='col-12 t-align-left mgt-5 mgb-5' style={{borderStyle:"dashed", borderColor:"#a19f9d"}}>
                                                        <div className='grid'>
                                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                                <label htmlFor="degree">{this.props.t("profile.areas.qualification.areas.physio-post-grad.degree")} <span className="invalid-message">*</span></label>
                                                                <Dropdown id="degree" value={grad.degreeLevel} disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} options={getPhysioPostGradList(getLanguage())} optionLabel="name" onChange={(evt) => this.updatePostGradData(grad.order, "degreeLevel", evt.value)}></Dropdown>
                                                                { this.state.validPhysioPostGradDegree[grad.order - 1] ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                            </div>
                                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                                <label htmlFor="degreeTitle">{this.props.t("profile.areas.qualification.areas.physio-post-grad.degree-title")} <span className="invalid-message">*</span></label>
                                                                <InputText id="degreeTitle" value={grad.trainingTitle} disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} type="text" onChange={(evt) => this.updatePostGradData(grad.order, "trainingTitle", evt.target.value)} />
                                                                { this.state.validPhysioPostGradTrainingTitle[grad.order - 1] ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                            </div>
                                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                                <label htmlFor="conclusionDate">{this.props.t("profile.areas.qualification.areas.physio-post-grad.conclusion-date")} <span className="invalid-message">*</span></label>
                                                                <Calendar value={grad.endDate} dateFormat="dd/mm/yy" maxDate={new Date()} disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} showIcon showButtonBar  onChange={(evt) => this.updatePostGradData(grad.order, "endDate", evt.target.value)}/>
                                                                { this.state.validPhysioPostGradEndDate[grad.order - 1] ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                            </div>
                                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                                <label htmlFor="school">{this.props.t("profile.areas.qualification.areas.physio-post-grad.school")} <span className="invalid-message">*</span></label>
                                                                <InputText id="school" value={grad.trainingSchool} disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} type="text" onChange={(evt) => this.updatePostGradData(grad.order, "trainingSchool", evt.target.value)}/>
                                                                { this.state.validPhysioPostGradTrainingSchool[grad.order - 1] ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                            </div>
                                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                                <label htmlFor="schoolCountry">{this.props.t("profile.areas.qualification.areas.physio-post-grad.school-country")} <span className="invalid-message">*</span></label>
                                                                <Dropdown id="schoolCountry" value={grad.trainingCountry} disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} options={WORLD_LIST} optionLabel="name" onChange={(evt) => this.updatePostGradData(grad.order, "trainingCountry", evt.value)}></Dropdown>
                                                                { this.state.validPhysioPostGradSchoolCountry[grad.order - 1] ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                            </div>
                                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                        
                                                            </div>
                                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                                <label htmlFor="recognitionSchool">{this.props.t("profile.areas.qualification.areas.physio-post-grad.recognition-school")} </label>
                                                                <InputText id="recognitionSchool" value={grad.acceptanceSchool} disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} type="text" onChange={(evt) => this.updatePostGradData(grad.order, "acceptanceSchool", evt.target.value)}/>
                                                            </div>
                                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                                <label htmlFor="recognitionDate">{this.props.t("profile.areas.qualification.areas.physio-post-grad.recognition-date")} </label>
                                                                <Calendar value={grad.acceptanceDate} dateFormat="dd/mm/yy" maxDate={new Date()} disabled={this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION} showIcon showButtonBar  onChange={(evt) => this.updatePostGradData(grad.order, "acceptanceDate", evt.target.value)}/>
                                                            </div>
                                                            <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                                <i className="pi pi-trash c-pointer" style={{ fontSize: '1.9rem' }} title={this.props.t("general.delete")} onClick={(evt) => this.deletePostGradData(grad.order)}></i>
                                                            </div>
                                                            <div className='col-12'><hr/></div>
                                                        </div>
                                                    </div>
                                        })
                                    }
                                    {
                                        !this.state.addTrainingMode && this.physioPostGrads.length < 10 ?
                                            <div className='col-12 t-align-center'>
                                                <Button icon="pi pi-plus" className="mr-2 mb-2" style={{width: "200px"}} onClick={() => this.setTrainingMode()}>
                                                    <span className={isMobileOnly ? '' : 'mgl-10'}>{this.props.t("profile.areas.qualification.areas.physio-post-grad.add-training")}</span>
                                                </Button>                              
                                            </div>
                                            : null
                                    }
                                    {
                                        this.state.addTrainingMode ?
                                            <div className='col-12 t-align-left mgt-5 mgb-5' style={{borderStyle:"dashed", borderColor:"#a19f9d"}}>
                                                <div className='grid'>
                                                    <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                        <label htmlFor="editDegree">{this.props.t("profile.areas.qualification.areas.physio-post-grad.degree")} <span className="invalid-message">*</span></label>
                                                        <Dropdown id="editDegree" value={this.state.cursorDegree} options={getPhysioPostGradList(getLanguage())} optionLabel="name" onChange={(evt) => this.setState({ cursorDegree: evt.value })}></Dropdown>
                                                        { this.state.validDegree ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                        <label htmlFor="editDegreeTitle">{this.props.t("profile.areas.qualification.areas.physio-post-grad.degree-title")} <span className="invalid-message">*</span></label>
                                                        <InputText id="editDegreeTitle" value={this.state.cursorTrainingTitle} type="text" onChange={(evt) => this.setState({ cursorTrainingTitle: evt.target.value })}/>
                                                        { this.state.validTrainingTitle ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                        <label htmlFor="editConclusionDate">{this.props.t("profile.areas.qualification.areas.physio-post-grad.conclusion-date")} <span className="invalid-message">*</span></label>
                                                        <Calendar value={this.state.cursorEndDate} dateFormat="dd/mm/yy" maxDate={new Date()} showIcon showButtonBar onChange={(evt) => this.setState({ cursorEndDate: evt.value })}/>
                                                        { this.state.validEndDate ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                        <label htmlFor="editSchool">{this.props.t("profile.areas.qualification.areas.physio-post-grad.school")} <span className="invalid-message">*</span></label>
                                                        <InputText id="editSchool" value={this.state.cursorTrainingSchool} type="text" onChange={(evt) => this.setState({ cursorTrainingSchool: evt.target.value })}/>
                                                        { this.state.validTrainingSchool ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                        <label htmlFor="editSchoolCountry">{this.props.t("profile.areas.qualification.areas.physio-post-grad.school-country")} <span className="invalid-message">*</span></label>
                                                        <Dropdown id="editSchoolCountry" value={this.state.cursorTrainingCountry} options={WORLD_LIST} optionLabel="name" onChange={(evt) => this.setState({ cursorTrainingCountry: evt.value })}></Dropdown>
                                                        { this.state.validSchoolCountry ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                        <label htmlFor="editRecognitionSchool">{this.props.t("profile.areas.qualification.areas.physio-post-grad.recognition-school")} </label>
                                                        <InputText id="editRecognitionSchool" value={this.state.cursorAcceptanceSchool} type="text" onChange={(evt) => this.setState({ cursorAcceptanceSchool: evt.target.value })}/>
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                        <label htmlFor="editRecognitionDate">{this.props.t("profile.areas.qualification.areas.physio-post-grad.recognition-date")} </label>
                                                        <Calendar value={this.state.cursorAcceptanceDate} dateFormat="dd/mm/yy" maxDate={new Date()} showIcon showButtonBar onChange={(evt) => this.setState({ cursorAcceptanceDate: evt.value })}/>
                                                    </div>
                                                    <div className='col-12 md:col-12 lg:col-4 t-align-left'>
                                                        <i className="pi pi-save c-pointer" style={{ fontSize: '1.9rem' }} title={this.props.t("general.save")} onClick={(evt) => this.savePostGradData()}></i>
                                                        <i className="pi pi-ban c-pointer" style={{ fontSize: '1.9rem' }} title={this.props.t("general.cancel")} onClick={(evt) => this.cancelAddPostGradData()}></i>
                                                    </div>
                                                </div>
                                            </div>
                                            : null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_REVISION ?
                            <div className="mgt-20">
                                <div className="grid">
                                    <div className="col-4 t-align-left mgt-10">
                                        <Button label={this.props.t("general.back")} severity="info" raised outlined onClick={(evt) => this.props.onBack()} />
                                    </div> 
                                    <div className="col-4 t-align-center mgt-10">
                                        <Button icon="pi pi-question-circle" severity='success' label="Verificar passo 5" raised />
                                    </div> 
                                    <div className="col-4 t-align-right mgt-10">
                                        <Button label={this.props.t("general.next")} severity="info" raised outlined onClick={(evt) => this.props.onNext()} />
                                    </div> 
                                </div>
                            </div>
                            : null
                    }
                </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        registrationState: state.authentication.registrationState,
        formFields: state.form.formFields,
        language: state.profile.language
    } 
};
  
const mapDispatchToProps = (dispatch) => {
    return {
        updateFormStep: (stepFields) => { dispatch(updateFormStep(stepFields)) },
        updateStep5State: (state) => { dispatch(updateStep5State(state)) }
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(RegistrationFormStep5Component));